<template>
    <el-dialog :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :title="title"
               width="860px"
               :before-close="doClose"
               custom-class="notice-dialog">

        <el-carousel :autoplay="false"
                     :class="{'show-close':showCloseBtn}"
                     :initial-index="active"
                     @change="handleChangeIndex"
                     :loop="false"
                     trigger="click"
                     arrow="always">
            <el-carousel-item v-for="(item, index) in tips"
                              :key="index">
                <div class="content">
                    <h3 class="title">{{item.title}}</h3>
                    <p class="description">{{item.description}}</p>
                    <img class="image"
                         :src="item.image"
                         alt="">

                    <p class="items">
                        <span v-for="(text, key) in item.items"
                              :style="{ width: getWidth(item.items.length) }"
                              :key="key">
                            <span class="cricle-icon">
                                {{key + 1}}
                            </span>
                            {{text}}
                        </span>
                    </p>

                    <div v-if="showCloseBtn"
                         class="text-center close-btn">
                        <el-button type="primary"
                                   @click="doClose">开始使用</el-button>
                    </div>

                </div>
            </el-carousel-item>
        </el-carousel>

    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            active: 0,
            showCloseBtn: false,
        };
    },
    watch: {
        active (nv) {
            if (nv === this.tips.length - 1) {
                setTimeout(() => {
                    this.showCloseBtn = true;
                }, 200);
            } else {
                this.showCloseBtn = false;
            }
        }
    },
    computed: {
        isPersonal () {
            return this.$store.getters.isPersonal;
        },
        tips () {
            let result = [
                {
                    title: '如何使用电子印章签署文件？',
                    description: '上传本地文件（pdf格式），拖入印章并验证身份完成签署。',
                    image: require('../assets/images/notice/2.jpg'),
                    items: ['上传PDF文件', '拖动印章选择印章位置', '完成签署']
                },
                {
                    title: '如何验证电子签名是否有效？',
                    description: '上传已经签署的电子文件，并查看验证结果。',
                    image: require('../assets/images/notice/3.jpg'),
                    items: ['上传电子文件', '验证结果']
                },
            ];
            if (this.isPersonal) {
                result.unshift({
                    title: '如何申请电子印章？',
                    description: '绘制或自动生成个人签名，成功后即可在签署页面使用个人签名',
                    image: require('../assets/images/notice/5.png'),
                    items: ['点击“个人签名”入口', '选择生成方式', '设置签名']
                });
            } else {
                result.unshift({
                    title: '如何申请电子印章？',
                    description: '上传印章模块，并等待审核通过，申请成功的印章可以写入Ukey',
                    image: require('../assets/images/notice/1.jpg'),
                    items: ['点击“印章管理”入口', '申请印章', '写入USBKey']
                });
            }
            return result;
        }
    },
    props: {
        visible: Boolean,
        title: String
    },
    methods: {
        getWidth (count) {
            return `${(660 - (count - 1) * 20) / count / 660 * 100}%`;
        },
        handleChangeIndex (index) {
            this.active = index;
        },
        doClose () {
            this.$emit('update:visible', false);
            this.axios({
                url: '/user/flush',
                method: 'GET'
            });
        }
    }
};
</script>

<style lang="less">
.notice-dialog {
    .content {
        text-align: left;
        padding: 0 40px;

        .description {
            margin: 10px auto 30px;
        }
    }

    .el-dialog__body {
        padding-top: 10px;
    }

    .el-carousel__container {
        height: 360px;
    }
    .show-close {
        .el-carousel__container {
            height: 400px;
        }
    }

    .el-carousel__indicator {
        .el-carousel__button {
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background: @grey;
        }

        &.is-active {
            .el-carousel__button {
                background: @red;
            }
        }
    }
    .el-carousel__arrow--right {
        right: 4px;
    }
    .el-carousel__arrow--left {
        left: 4px;
    }
    .close-btn {
        margin: 20px auto;
    }
    .items {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        span {
            display: inline-block;
        }
    }
    .cricle-icon {
        width: 14px;
        height: 14px;
        line-height: 14px;
        border-radius: 14px;
        font-size: 12px;
        background: @red;
        color: @white;
        text-align: center;
    }
}
</style>



